<article>
  <div class="icon">
    <img
      class="war wk-padding-bottom-24"
      src="./assets/images/icon-casita-warning.png"
      alt="Servicio exclusivo para clientes"
    />
  </div>
  <div class="text">
    <h1 class="title">Necesitas ser cliente Bci</h1>
    <p class="subtitle">
      El servicio de agendamiento es exclusivo para clientes. Te invitamos a ser
      parte de Bci.
    </p>
  </div>

  <div class="actions">
    <button bciWkButtonSecondary (click)="cancel()">Entendido</button>
    <button *ngIf="goClient" bciWkButtonPrimary (click)="goAccept()">
      Ir a Hazte Cliente
    </button>
  </div>
</article>
